import { render, staticRenderFns } from "./Haunted.vue?vue&type=template&id=0a9f30fd&scoped=true&"
import script from "./Haunted.vue?vue&type=script&lang=js&"
export * from "./Haunted.vue?vue&type=script&lang=js&"
import style0 from "./Haunted.vue?vue&type=style&index=0&id=0a9f30fd&prod&scoped=true&lang=css&"
import style1 from "./Haunted.vue?vue&type=style&index=1&id=0a9f30fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f30fd",
  null
  
)

export default component.exports